import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import formReducer from "./serviceReducer";
import formReducerGlobal from "./serviceReducerGlobala";

// wizard form data: session-scoped (lost on tab close, survives navigation)
const persistConfigForm = {
	key: "form",
	version: 1,
	storage: storageSession,
};

// global app state: browser-scoped (survives tab close, holds user session)
const persistConfigGlobal = {
	key: "root",
	version: 1,
	storage,
};

const persistedFormReducer = persistReducer(persistConfigForm, formReducer);
const persistedGlobalReducer = persistReducer(persistConfigGlobal, formReducerGlobal);

export const store = configureStore({
	reducer: {
		from: persistedFormReducer,
		another: persistedGlobalReducer,
	},
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}),
});

export const persistor = persistStore(store);
